var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticClass: "widthSettingMenu",
      attrs: {
        left: "",
        top: "",
        "offset-x": "",
        "close-on-click": true,
        "close-on-content-click": false
      },
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "textCenter",
          attrs: { slot: "activator" },
          slot: "activator"
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "" } }, [
                _vm.statusroom !== "close"
                  ? _c(
                      "span",
                      { staticClass: "pl-1 cursorpointer colorFooterMenu" },
                      [
                        _c("v-icon", { staticStyle: { "font-size": "14px" } }, [
                          _vm._v("settings")
                        ]),
                        _vm._v(" ตัวเลือก")
                      ],
                      1
                    )
                  : _c(
                      "span",
                      {
                        staticClass: "pl-1 cursorpointer colorFooterMenu",
                        attrs: { disabled: "" }
                      },
                      [
                        _c("v-icon", { staticStyle: { "font-size": "14px" } }, [
                          _vm._v("settings")
                        ]),
                        _vm._v(" ตัวเลือก")
                      ],
                      1
                    )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "setBGMenuSetting setMaxWidthMenuSetting" },
        [
          _c(
            "v-layout",
            {
              staticStyle: { "background-color": "#e0e0e0" },
              attrs: {
                row: "",
                wrap: "",
                "align-center": "",
                "justify-center": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs3: "" } },
                [
                  _c(
                    "v-avatar",
                    { staticClass: "f-l mr-2 user-photoprofilechat" },
                    [
                      _c("img", {
                        staticClass: "alligator-turtle",
                        attrs: {
                          src: "/static/img/call-center.png",
                          alt: "John"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs7: "" } }, [
                _vm.statusroom !== "close"
                  ? _c("span", [_c("b", [_vm._v("ตัวเลือก")])])
                  : _c("span", { attrs: { disabled: "" } }, [
                      _c("b", [_vm._v("ตัวเลือก")])
                    ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs2: "" } }, [
                _c(
                  "span",
                  [
                    _c(
                      "v-icon",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.menu = false
                          }
                        }
                      },
                      [_vm._v("close")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.statusroom !== "close"
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    _vm._l(_vm.listmenu, function(item, index) {
                      return _c(
                        "div",
                        { staticStyle: { "margin-bottom": "1px" } },
                        [
                          item.label != "v-divider"
                            ? _c(
                                "div",
                                {
                                  staticClass: "cursorpointer colorMenu",
                                  on: {
                                    click: function($event) {
                                      return _vm.clickchange(item.value, index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-left": "1vw",
                                        "margin-right": "170px"
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(item.label) + " ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    { staticStyle: { "font-size": "15px" } },
                                    [_vm._v(_vm._s(item.icon))]
                                  )
                                ],
                                1
                              )
                            : _c("v-divider", {
                                staticStyle: {
                                  "margin-top": "2px",
                                  "margin-bottom": "2px"
                                }
                              })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "1vw",
                                "margin-right": "170px"
                              },
                              attrs: { disabled: "" }
                            },
                            [_vm._v("เสียง")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "15px" },
                              attrs: { disabled: "" }
                            },
                            [_vm._v("fas fa-volume-off")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider", {
                        staticStyle: {
                          "margin-top": "2px",
                          "margin-bottom": "2px"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "100%" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: { "margin-left": "1vw" },
                            attrs: { disabled: "" }
                          },
                          [_vm._v("ส่งไฟล์")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-divider", {
                        staticStyle: {
                          "margin-top": "2px",
                          "margin-bottom": "2px"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cursorpointer colorMenu",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: { "margin-left": "1vw" },
                              attrs: { disabled: "" },
                              on: {
                                click: function($event) {
                                  return _vm.clickchange("endchatpage")
                                }
                              }
                            },
                            [_vm._v("สิ้นสุดการสนทนา")]
                          )
                        ]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "none" } }, [
        _c("input", {
          attrs: { type: "file", id: "uploadfileChat" },
          on: { change: _vm.onFileSelected }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a60cd91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a60cd91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menusetting.vue
// module id = null
// module chunks = 